import { render, staticRenderFns } from "./MainTab.vue?vue&type=template&id=2a13d72d&"
import script from "./MainTab.vue?vue&type=script&lang=js&"
export * from "./MainTab.vue?vue&type=script&lang=js&"
import style0 from "./MainTab.vue?vue&type=style&index=0&id=2a13d72d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports